<template lang="pug">
.make-appointment
  .header-margin-bottom
  .member-center-header
    h1 會員中心
      .points
        img(src="../assets/images/points.png", alt="alt")
        span 2
  .membox
    img.user-pic(:src="$root.member.user_picture", alt="alt")
    .qr-box(@click="$root.goPage('/member-scan')")
      img(src="../assets/images/small_QRCode.svg", alt="alt")
  .sub-title(@click="goRegister") 我要預約
  .reservation-type
    button.type-item(@click="$root.goPage('/appointment-online')")
      .type-num {{ $root.registerOrders.length }}
      p 我的預約
    button.type-item
      .type-num 0
      p 擁有票券
  .info-list
    .info-item
      .info-title 帳號資料
      .info-group
        h2 真實姓名
        p {{ $root.member.name }} ( {{ $root.member.name }} )
        .icon-box(@click="$root.goPage('/change-name')")
          img(src="@/assets/images/member_icon.svg")
      .info-group
        h2 電話（帳號）
        p.retracted {{ $root.member.user_phone }}
    .info-item
      .info-title 租借歷史
      .info-content(@click="$root.goPage('/loan-history')")
        h2 歷史紀錄
        .arrow-box
          img(src="@/assets/images/arrow_right.svg")

  .rules-info.text-center
    .rule-text
      a(href="https://www.didifun.store/user-agreement-zh" target="_new") 零碳智慧租賃系統服務條款
    .rule-text
      a(href="https://www.didifun.store/privacy-policy-zh" target="_new") 零碳智慧租賃系統隱私權保護政策
</template>

<script>
export default {
  name: "make-appointment",
  components: {},
  data () {
    return {};
  },
  mounted () {
  },
  created () {
    this.$root.getReserveOrders()
  },
  methods: {
    goRegister () {
      this.$root.goPage('/reserve-select-main-type')
    }
  },
};
</script>
<style lang="sass" scoped>
.make-appointment
  background-color: #000
  padding: 0 4vmin 5vmin
  height: 100%
  // overflow: auto
  h1
    font-size: 5vmin
    font-weight: 700
    text-align: center
    color: #fff
    height: 8vmin
    margin: 6vmin 3vmin
    position: relative
  .points
    display: flex
    align-items: center
    gap: 13px
    position: absolute
    right: 0
    top: 1vmin
    img
      margin: 0
      height: 23px
    span
      color: #22F48F
      font-size: 4.2vmin
      font-weight: 500
  .membox
    width: 26.5vmin
    height: 27.25vmin
    margin-top: 12.5vmin
    margin-inline: auto
    background-color: #fff
    border-radius: 50%
    display: flex
    position: relative
    img
      margin-block: auto
    img.user-pic
      border-radius: 100%
    .qr-box
      width: 12.5vmin
      height: 12.5vmin
      border-radius: 50%
      background-color: #22F48F
      position: absolute
      right: 0
      bottom: -2vmin
      display: flex
      img
        margin-block: auto
  .sub-title
    width: 41vmin
    margin: auto
    text-align: center
    font-size: 6vmin
    font-weight: 700
    color: #1E1E1E
    margin-top: 7.25vmin
    padding: 2.75vmin
    border-radius: 25vmin
    background-color: #22F48F
  .reservation-type
    margin-top: 6.25vmin
    display: flex
    justify-content: center
    .type-item
      width: 43.75vmin
      background-color: #1E1E1E
      padding: 3vmin
      border: none;
      cursor: pointer
      &:first-child
        border-radius: 10px 0 0 10px
      &:last-child
        border-radius: 0 10px 10px 0
      .type-num
        color: #FFF
        text-align: center
        font-size: 16vmin
        font-weight: 700
        padding: 3vmin
      p
        color: #FFF
        text-align: center
        font-size: 3.5vmin
        font-weight: 300
  .info-list
    margin-top: 9vmin
    .info-item
      margin-top: 5vmin
      .info-title
        font-size: 4.5vmin
        font-weight: 700
        color: #22F48F
      .info-group,.info-content
        display: flex
        justify-content: space-between
        align-items: center
        padding: 7vmin 2vmin
        .retracted
          margin-right: auto
        h2
          font-size: 4.7vmin
          font-weight: 400
          color: #898A8D
          width: 34vmin
        p
          font-size: 4.7vmin
          font-weight: 400
          color: #FCFCFE
          flex: 1
        .icon-box
          width: 6vmin
          position: relative
          top: .5vmin
          height: 6vmin
        .arrow-box
          width: 3vmin
          height: 6.5vmin
          img
            width: 100%
.rules-info
  padding-top: 15px
  padding-bottom: 5px
  border-top: solid 1px #FFF
  .rule-text
    font-size: 12px
    text-align: center
    .rule-text
      margin-bottom: 5px
    a
      color: #FFF
  .text-center
    text-align: center
.header-margin-bottom
  margin-bottom: 75px
.member-center-header
  position: fixed
  left: 0px
  top: 0px
  width: 100%
  background: #000
  z-index: 10
  height: 75px
</style>